import ApiServiceV6 from '@/helpers/api.service.v6lite';

import { Storage } from 'aws-amplify';
import moment from "moment";

const APIV6 = new ApiServiceV6();

// Endpoints
const MOP_ENDPOINT = '/mop';
const MOP_MODULE_ENPOINT = '/mop-modules';

export const state = {
  mops: [],
  mopModules: [],
  modules: [],
  errors: null,
  mopReasonLoglist: [],
  mopReasonLogPageInfo: {
    total: 0
  },
  mopLoglist: [],
  mopLogPageInfo: {
    total: 0
  },
  mopOptions: [],
  mopDetailsForm:null,
  mopMethodTypes: []
}

export const mutations = {
  SET_PROD_ERRORS(state, errors){
    state.errors = errors;
  },
  UPDATE_MOP_LIST(state, mops){
    state.mops = mops;
  },
  UPDATE_MOP_MODULE_LIST(state, mopModules){
    state.mopModules = mopModules;
  },
  UPDATE_MODULE_LIST(state, modules){
    state.modules = modules;
  },
  UPDATE_REASON_LIST(state, list) {
    state.mopReasonLoglist = list;
  },
  UPDATE_REASON_PAGE_INFO(state, total) {
    state.mopReasonLogPageInfo.total = total;
  },
  UPDATE_LOG_LIST(state, list) {
    state.mopLoglist = list;
  },
  UPDATE_LOG_PAGE_INFO(state, total) {
    state.mopLogPageInfo.total = total;
  },
  UPDATE_MOP_OPTIONS(state, opt) {
    state.mopOptions = opt;
  },
  UPDATE_MOP_DETAILS(state, opt) {
    state.mopDetailsForm = opt;
  },
  UPDATE_MOP_METHOD_TYPES(state, methodTypes) {
    state.mopMethodTypes = methodTypes;
  },
}

export const actions = {
  // MOPs
  listMop(context,params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_MOP_LIST', data.message);
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  createMop(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject(response);
        });
    });
  },
  updateMop(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  deleteMop(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_ENDPOINT}/delete`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getMop(context, id){
    return new Promise((resolve, reject) => {
      var params = { mopId: id };
      APIV6.post(`${MOP_ENDPOINT}/detail`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve(Object.assign(data.message, { methodType: data.message?.type + (data.message?.code ?? "") }));
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getMethodTypes(context){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_ENDPOINT}/method-types`, {})
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_MOP_METHOD_TYPES', data.message);
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },

  // MOP Modules
  listMopModules(context,params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_MOP_MODULE_LIST', data.message);
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  createMopModule(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject(response);
        });
    });
  },
  updateMopModule(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  deleteMopModule(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/delete`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getMopModule(context, id){
    return new Promise((resolve, reject) => {
      var params = { methodId: id };
      APIV6.post(`${MOP_MODULE_ENPOINT}/detail`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_MOP_DETAILS', data.message);
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getModules(context){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/list-modules`)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_MODULE_LIST', data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  updateModuleOrder(context, orderData){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/update-modules-order`, {
        sequence: orderData
      })
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  // Logo upload
  uploadLogo(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(30, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      Storage.put(`${params.folder}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  },
  updateMopStatus(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_ENDPOINT}/update-status`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  updateMopMethodStatus(context, params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/update-status`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            console.log('test this 2');
            resolve(data);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject(response.data);
        });
    });
  },
  // list all mop, for filter by payment method options
  listAllMop(context,params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_ENDPOINT}/list-all-mop`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_MOP_LIST', data.message);
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getMopReasonList(context, params) {
    console.log('MOP LIST');
    return new Promise((resolve, reject) => {
      APIV6.post(`/mop/logs/list`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_REASON_LIST', data.message.rows);
            context.commit('UPDATE_REASON_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },

  getMopLogList(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/mop/logs/listv2`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            context.commit('UPDATE_LOG_LIST', data.message.rows);
            context.commit('UPDATE_LOG_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },

  exportMopLogList(context, params) {
    return new Promise((resolve, reject) => {
      APIV6.post(`/mop/logs/export`, params)
        .then(({ data }) => {
          if (data.status == "err") {
            reject();
          } else {
            // context.commit('UPDATE_LOG_LIST', data.message.rows);
            // context.commit('UPDATE_LOG_PAGE_INFO', data.message.pageInfo.total);
            resolve();
          }
        })
        .catch((response) => {
          console.log(response.data);
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        })
    });
  },

  // MOPs per module
  getMopModuleOpt(context,params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/get-mop-module`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            context.commit('UPDATE_MOP_OPTIONS', []);
            reject();
          } else {
            context.commit('UPDATE_MOP_OPTIONS', data.message);
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  // MOP Scheduler Create
  actionMopDetailsScheduler(context,params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/action-mop-details-scheduler`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  // MOP Scheduler test
  testMopDetailsScheduler(context,params){
    return new Promise((resolve, reject) => {
      APIV6.post(`${MOP_MODULE_ENPOINT}/mop-details-scheduler`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
}